@if (items.length > 0) {
  <mat-action-list>
    @for (item of items; track item) {
      <button (click)="action.emit(item)"
        [ngClass]="['plausible-event-name=Catalog+Topic plausible-event-title='+item.label.replaceAll(' ', '+')]"
        mat-list-item>
        <span matListItemTitle>
          {{ item.label }}
        </span>
        @if (showCount) {
          <span matListItemMeta>{{ item.count }}</span>
        }
      </button>
    }
  </mat-action-list>
}

@if (items.length === 0) {
  <div class="p-3 text-error">
    {{ 'catalog.topic.no_results' | transloco }}
  </div>
}
